module.exports = __webpack_public_path__ + "img/WechatIMG2.c0d0b0b1.png";